import Vue from 'vue'

// State
const state = {
  isLoading: false,
  data: null
}

// Mutations
const fetchArrowsRequest = 'fetchArrowsRequest'
const fetchArrowsResponse = 'fetchArrowsResponse'

const prettify = label => {
  return label.replace(/_/g, ' ').replace(/\+/g, '⁺')
}

const mutations = {
  [fetchArrowsRequest] (state) {
    state.isLoading = true
  },
  [fetchArrowsResponse] (state, arrows) {
    state.isLoading = false
    state.data = Object.keys(arrows).map(group => ({
      group: prettify(group),
      arrows: arrows[group].map(arrow => ({
        label: prettify(arrow),
        value: `${group}/${arrow}`
      }))
    }))
  }
}

// Actions
export const fetchArrows = 'fetchArrows'
const actions = {
  [fetchArrows]: ({ commit }) => {
    commit(fetchArrowsRequest)
    return Vue.http.get(`${SERVER_URL}/arrows`).then(({ data: arrows }) => {
      commit(fetchArrowsResponse, arrows)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrows.js